import React, { useContext } from 'react'
import { ProgressBar } from 'react-bootstrap'
import PayPopup from '../components/PayPopup'
import HeadTitle from '../layout/HeadTitle'
import { OrdersContext, PopUpContext } from '../layout/Root'

export default function TotalOrders() {
   const [totalOrders, setTotalOrders] = useContext(OrdersContext)
   const [, setPopUp] = useContext(PopUpContext)

   const OrderProgress = ({ o }) => {
      const variant = o.status === 'In Progress' ? 'danger' : o.status === 'In Preparation' ? 'info' : 'success'
      const now = o.status === 'In Progress' ? 33 : o.status === 'In Preparation' ? 66 : 100
      return <ProgressBar striped animated variant={variant} label={o.status} now={now} />
   }

   const changeStatus = (newStatus, userId, orderId) => {
      setTotalOrders(old =>
         old.map(o => o.user._id !== userId ?
            o :
            ({ ...o, orders: o.orders.map(or => or._id !== orderId ? or : ({ ...or, status: newStatus })) }))
      )
   }

   return (
      <>
         <HeadTitle title='total orders' />
         <div className='container-fluid'>
            <div className="container py-3">

               {totalOrders.map(o =>
                  <div key={o.user?._id} className="row">
                     <div className="col-12  p-2">
                        <h2> table number - {o.user.table}</h2>
                     </div>
                     {o.orders?.map((or, index) =>
                        <div key={or?._id} className="col-lg-3 col-md-4 col-6 p-1 slide-in-left" style={{ animationDelay: `${index * 2}00ms` }}>
                           <div className="card p-2">
                              <h5 className='my-3'>{or.title}</h5>
                              <p>Amount: {or.amount}</p>
                              {or.notes && <p>Notes: {or.notes} </p>}
                              <p>Price: ${or.price} per dish</p>

                              <select value={or.status} className="form-select mb-2" onChange={e => changeStatus(e.target.value, o.user._id, or._id)} >
                                 <option value="In Progress">In Progress</option>
                                 <option value="In Preparation">In Preparation</option>
                                 <option value="Served">Served</option>
                              </select>
                              <OrderProgress o={or} />
                           </div>
                        </div>
                     )}

                     <div className='col-12 p-4'>
                        <h3>total price: ${o?.orders?.reduce((prev, curr) => (curr.price * curr.amount) + prev, 0)} </h3>
                        {!o?.info?.paid && <button onClick={() => setPopUp({ title: 'pay order', component: <PayPopup order={o} /> })} className='btn btn-primary me-2'>pay now $ </button>}
                        <p className={(!o?.info?.paid ? ' text-bg-danger' : 'text-bg-success') + ' badge p-2'}>{!o?.info?.paid ? 'not paid' : 'paid'}</p>
                     </div>
                  </div>
               )
               }
            </div>
         </div>
      </>
   )
}


